<template>
  <div class="home">
    <div class="block">
      <h2>Actions</h2>
      <b-button
        variant="dark"
        class="border border-light"
        :disabled="$store.getters.isRequestPending('reloadBuilds')"
        @click="$store.dispatch('reloadBuilds').catch(e => {})"
        ><span v-if="!$store.getters.isRequestPending('reloadBuilds')"
          >Reload builds</span
        >
        <span v-else>
          <b-spinner small type="grow" />
          Loading...
        </span></b-button
      >
      <b-button
        variant="dark"
        class="border border-light"
        :disabled="$store.getters.isRequestPending('updateBuildsStatuses')"
        @click="$store.dispatch('updateBuildsStatuses').catch(e => {})"
        ><span v-if="!$store.getters.isRequestPending('updateBuildsStatuses')"
          >Update builds statuses</span
        >
        <span v-else>
          <b-spinner small type="grow" />
          Loading...
        </span></b-button
      >
      <b-button
        variant="dark"
        class="border border-light"
        :disabled="!whitelabelId"
        @click="
          $store.dispatch('reloadBuildsForWl', { whitelabelId }).catch(e => {})
        "
        ><span v-if="!$store.getters.isRequestPending('reloadBuildsForWl')"
          >Reload builds for wl</span
        >
        <span v-else>
          <b-spinner small type="grow" />
          Loading...
        </span></b-button
      >
      <b-form-input
        v-model="whitelabelId"
        class="whitelabelId"
        placeholder="Enter whitelabelId"
        md="3"
      />
    </div>
    <div class="block">
      <h2>Console</h2>
      <Console></Console>
    </div>
    <b-container class="block w-100">
      <b-row>
        <b-col
          ><h2>Update statuses by WL</h2>
          <div v-if="Object.keys($store.state.ws.wlStatuses).length > 0">
            <div
              v-for="(value, index) in $store.state.ws.wlStatuses"
              v-b-popover.hover="value.join('\n')"
              class="wlStatusRow"
            >
              <span class="wlName">{{ index }}</span>
              {{ value[value.length - 1] }}
            </div>
          </div>
          <div v-else>
            No update info. Maybe update was never started since app launch?
          </div>
        </b-col>
        <b-col
          ><h2>Builds check statuses</h2>
          <div v-if="Object.keys($store.state.ws.buildsStatuses).length > 0">
            <div
              v-for="(value, index) in $store.state.ws.buildsStatuses"
              v-b-popover.hover="value.join('\n')"
              class="buildStatusRow"
            >
              <span class="buildName">{{ index }}</span>
              {{ value[value.length - 1] }}
            </div>
          </div>
          <div v-else>
            No active check processes. It seems like update has finished already
            or never started.
          </div></b-col
        >
        <b-col
          ><h2>Last builds processing errors</h2>
          <div
            v-if="
              $store.state.ws.buildsErrors.error &&
                $store.state.ws.buildsErrors.error.length > 0
            "
          >
            <div v-for="value in $store.state.ws.buildsErrors.error">
              {{ value.build }}
            </div>
          </div>
          <div v-else>
            No last errors. It seems like everything is ok or update has never
            started.
          </div></b-col
        >
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Console from '../components/Console';
export default {
  data() {
    return {
      whitelabelId: null
    };
  },

  name: 'dashboard',
  components: { Console }
};
</script>

<style scoped type="text/scss">
.block {
  border-bottom: #dadada 1px solid;
  padding-bottom: 1em;
  margin-bottom: 3em;
}
.container {
  max-width: none;
}
.wlName {
  width: 7em;
  display: inline-block;
  font-weight: bold;
}
.wlStatusRow:hover {
  background: #fafafa;
}
.whitelabelId {
  display: inline-block;
  width: 160px;
  margin-left: 2px;
}
.buildName {
  width: 100%;
  display: inline-block;
  font-weight: bold;
}
.buildStatusRow:hover {
  background: #fafafa;
}
</style>
